<div class="notifications-bar-tile-wrapper" [class.info]="level==='info'">
	<i class='icon' [class]="level==='warn'?'cp-icon-warning':'cp-icon-info'"></i>
	{{text | cpMessageTranslate: {a0: textParameter} }}
	<ng-content> </ng-content>
	<i *ngIf="showCloseButton" class="close-button cp-sh-icon-close_btn" (click)="close.emit();"></i>
</div>
